import React, { useState } from 'react'
import Modal from '../../components/Modal'
import Text from '../../components/Text'
import ResetForm from '../../forms/Reset'
import { Container, Form } from './styles'
import { useHistory, useParams, Redirect } from 'react-router-dom'
import routes from '../../config/routes'
import { GuestArea } from '@polvo-labs/react-auth'

interface Props {

}

const ResetScreen: React.FC<Props> = () => {
  const history = useHistory()
  const [submitted, setSubmitted] = useState(false)
  const { token } = useParams<{ token: string }>()

  if (!token) {
    return (
      <Redirect
        to={routes.index.path}
      />
    )
  }

  return (
    <GuestArea>
      <Modal
        open
        small
        onToggle={() => history.push(routes.index.path)}
      >
        <Container>
          <Form>
            <Text
              tag="h2"
              align="center"
            >
              ESQUECI MINHA SENHA
            </Text>

            {!submitted ? (
              <ResetForm
                token={token}
                onSubmit={() => {
                  setSubmitted(true)
                  setTimeout(() => {
                    history.push(routes.login.path)
                  }, 5000)
                }}
              />
            ) : (
              <p>Sua senha foi redefinida, você será redirecionado
                para o login em seguida.</p>
            )}
          </Form>
        </Container>
      </Modal>
    </GuestArea>
  )
}

export default ResetScreen
